export default "__VITE_ASSET__9a23ead3__"